/** Outbound links used across the site, in one place so they stay consistent. */

export const GITHUB_URL = "https://github.com/jvnkr/OpenVOD";
export const RELEASES_URL = `${GITHUB_URL}/releases/latest`;
export const ISSUES_URL = `${GITHUB_URL}/issues`;

/** Games the desktop app records with full match data today. */
export const SUPPORTED_GAMES = ["League of Legends", "Teamfight Tactics", "Valorant"] as const;
